// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c2b9254b","186":"bb859eeb","225":"cf4c037f","272":"da6c1784","372":"6ba2757a","377":"7ce1ee69","573":"e3becfae","738":"a70f482c","841":"d9a59ee2","851":"4428cd6a","856":"9cbfa20f"}[chunkId] + ".chunk.js";
};